import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * PearsonLogoMojo Icon
 *
 * @file PearsonLogoMojo.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

const PearsonLogoMojo = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 60 60" {...props}>
    <g fill="none">
      <rect
        width="60"
        height="60"
        rx="13"
        fill="url(#paint0_linear_11587:14567)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.2572 38.353C49.8988 28.4639 48.011 18.6907 39.9036 14.3314C30.9457
          9.51361 19.2674 12.1349 14.2334 22.4537C10.7661 29.5585 12.3405 41.906 20.4082
          46.3328C28.4747 50.7572 39.2999 47.0449 44.2572 38.353ZM41.5176 27.8438C41.7926
          25.8537 41.2989 23.4279 39.7117 21.8288L39.6886 21.807C36.6396 18.5569
          32.4062 18.353 29.7255 18.4157C26.7621 18.4869 24.6339 19.4102 22.8932
          20.2671C21.3738 21.0141 20.004 22.2994 19.4476 22.9379C19.0934 23.3446
          18.491 24.1846 18.8145 24.9377C19.0806 25.5628 20.0794 25.5218 20.4555
          25.2551C20.6535 25.1141 20.8579 24.9345 21.0827 24.7369C21.2834 24.5605
          21.5003 24.3699 21.7434 24.1797C24.0315 22.3936 26.0599 21.2688 30.7857
          21.2688C35.5115 21.2688 38.072 24.0494 38.072 26.5319C38.072 29.0145
          36.8289 30.7005 34.4794 31.8011C33.3168 32.3454 32.0736 32.7666 30.5082
          32.8234C30.622 30.4169 30.6808 28.1395 30.6808 28.1395C30.6863 27.8543
          30.6993 27.5778 30.7117 27.3139C30.7747 25.9752 30.8225 24.9596 29.7958
          24.7651C28.5693 24.5322 26.3093 24.7615 26.2671 26.083C26.2121 25.8863
          26.4999 36.9122 26.5523 37.1295L26.5728 37.3829C26.5971 37.6629 26.702
          37.9091 26.8874 38.1058C27.0729 38.3001 27.3734 38.4208 27.6433 38.4498C27.6855
          38.4534 27.7277 38.457 27.7699 38.457C28.027 38.457 28.3889 38.4136 28.7534
          38.317C29.2139 38.1927 29.6769 37.9815 29.9442 37.6521C30.0797 37.4855 30.191
          37.3238 30.2486 37.0257C30.2882 36.8229 30.3662 35.5424 30.3867 35.1707C32.8717
          35.149 35.3977 34.7097 37.32 33.6042C39.7436 32.2127 41.2017 30.1127 41.5176
          27.8438ZM28.6588 39.7267C28.9389 39.7786 29.2151 39.9029 29.462 40.0839H29.462C29.9097
          40.4122 30.1783 40.9251 30.1833 41.4501C30.1872 41.9027 29.9864 42.307
          29.6168 42.593C29.2983 42.8344 28.889 42.9647 28.4337 42.9647H28.4324C28.2239
          42.9647 28.0155 42.9357 27.8121 42.8826C27.4591 42.7873 27.1752 42.6292 26.9897
          42.424C26.8235 42.2418 26.7122 41.9968 26.6636 41.7132C26.5894 41.2715 26.7058
          40.8141 26.9872 40.4327C27.3248 39.9729 27.8428 39.6989 28.3697 39.6989C28.4657
          39.6989 28.5641 39.7086 28.6588 39.7267Z"
        fill="#FEFEFE"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_11587:14567"
        x1="56.875"
        y1="-5.71133e-07"
        x2="7.13952e-07"
        y2="65.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#360017" />
        <stop offset="1" stopColor="#73016E" />
      </linearGradient>
    </defs>
  </SvgIcon>
);

export default PearsonLogoMojo;
